import * as marietta from '../..';
import { MonicaObject } from '.';
import { SVGSprite } from '../flash/display';
import { SITE_INPUT_MODE } from '../Constants';

export default class Site extends MonicaObject {
    nuriView: SVGElement;

    textView: SVGElement;

    roadView: SVGElement;

    lineView: SVGElement;

    altitudeView: SVGElement;

    roads: marietta.webcad.item.parts.SiteRoad[] = [];

    stretchLines: marietta.webcad.item.parts.SiteLine[] = [];

    stretchLineTexts: marietta.webcad.item.parts.SiteText[] = [];

    baseSideLine: marietta.webcad.item.parts.SiteLine;

    altitudeInfo: marietta.webcad.collection.AltitudeLineInfoCollection;

    altitudelineText: marietta.webcad.item.parts.SiteAltitudeLineText;

    lines: marietta.webcad.item.parts.SiteLine[];

    inputMode: number;

    /**
     * コンストラクタ
     */
    // constructor(_itemInfo: marietta.webcad.collection.ItemInfoCollection) {
    //   super(_itemInfo);
    // }

    /**
     * リドロー
     */
    reCreateImage=() => {
      this.nuriView.remove();
      this.textView.remove();
      this.lineView.remove();
      this.roadView.remove();
      this.altitudeView.remove();

      this.createImage();
    }

    /**
     * ビューの作成
     */
    createImage() {
      let viewObj: Element;
      if (!this.spt) {
        viewObj = document.createElementNS('http://www.w3.org/2000/svg', 'g');
        viewObj.setAttribute('id', `${this.itemInfo.id}_${this.itemInfo.guid}`);
      } else {
        viewObj = this.spt.element;
      }

      // 塗り
      this.nuriView = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      this.nuriView.setAttribute('fill', '#ECF2CE');
      this.nuriView.setAttribute('opacity', '0.5');
      this.nuriView.setAttribute('id', `${this.itemInfo.id}_${this.itemInfo.guid}_nuri`);
      this.nuriView.setAttribute('d', marietta.webcad.util.SVGUtil.getPathString(this.itemInfo.dotList));
      viewObj.appendChild(this.nuriView);

      // 高さ
      this.altitudeView = document.createElementNS('http://www.w3.org/2000/svg', 'g');
      this.altitudeView.setAttribute('id', `${this.itemInfo.id}_${this.itemInfo.guid}_altitude`);
      viewObj.appendChild(this.altitudeView);

      // 道路
      this.roads = [];
      this.roadView = document.createElementNS('http://www.w3.org/2000/svg', 'g');
      this.roadView.setAttribute('id', `${this.itemInfo.id}_${this.itemInfo.guid}_roadGroup`);
      viewObj.appendChild(this.roadView);
      let road: marietta.webcad.item.parts.SiteRoad;

      // 辺
      this.stretchLines = [];
      this.lines = [];
      this.lineView = document.createElementNS('http://www.w3.org/2000/svg', 'g');
      this.lineView.setAttribute('id', `${this.itemInfo.id}_${this.itemInfo.guid}_lineGroup`);
      viewObj.appendChild(this.lineView);
      let line: marietta.webcad.item.parts.SiteLine;

      // テキスト
      this.stretchLineTexts = [];
      this.textView = document.createElementNS('http://www.w3.org/2000/svg', 'g');
      this.textView.setAttribute('id', `${this.itemInfo.id}_${this.itemInfo.guid}_textGroup`);
      viewObj.appendChild(this.textView);
      let text: marietta.webcad.item.parts.SiteText;

      for (let i: number = 1; i <= this.itemInfo.dotList.length; i += 1) {
        road = new marietta.webcad.item.parts.SiteRoad(this, i);
        this.roads.push(road);
        // テキスト
        text = new marietta.webcad.item.parts.SiteText(this.textView, i);
        text.parent = this as marietta.webcad.item.Site;
        this.stretchLineTexts.push(text);
        line = new marietta.webcad.item.parts.SiteLine(this.lineView, i);
        line.partnerRoad = road;
        line.partnerText = text;
        line.partnerRoad.itemInfo = this.itemInfo;
        line.parent = this as marietta.webcad.item.Site;
        if (marietta.webcad.WebCADGlobal.webcad2Dmanager.currentSiteInputMode === SITE_INPUT_MODE.SITE_DETAILED_INPUT_MODE) {
          line.showTriangularSideLine();
        }
        this.stretchLines.push(line);
      }

      for (let i = 0; i < this.roads.length; i += 1) {
        road = this.roads[i];
        road.roadwidth = this.itemInfo.dotList[i].road_w;
        road.lr = this.itemInfo.dotList[i].road_lr;
        road.firstDot = this.itemInfo.dotList[i].point;
        if (i === this.roads.length - 1) {
          road.secondDot = this.itemInfo.dotList[0].point;
        } else {
          road.secondDot = this.itemInfo.dotList[i + 1].point;
        }
        road.updateTransforms();
      }

      for (let i = 0; i < this.stretchLines.length; i += 1) {
        line = this.stretchLines[i];
        line.firstDot = this.itemInfo.dotList[i].point;
        if (i === this.stretchLines.length - 1) {
          line.secondDot = this.itemInfo.dotList[0].point;
        } else {
          line.secondDot = this.itemInfo.dotList[i + 1].point;
        }
      }
      this.lines = this.stretchLines;

      // テキスト
      for (let i = 0; i < this.stretchLineTexts.length; i += 1) {
        text = this.stretchLineTexts[i];
        text.firstDot = this.itemInfo.dotList[i].point;
        if (i === this.stretchLineTexts.length - 1) {
          text.secondDot = this.itemInfo.dotList[0].point;
        } else {
          text.secondDot = this.itemInfo.dotList[i + 1].point;
        }
      }

      // テキストのパートナーの登録
      for (let i = 0; i < this.stretchLineTexts.length; i += 1) {
        (this.stretchLineTexts[i] as marietta.webcad.item.parts.SiteText).linePartner = this.stretchLines[i] as marietta.webcad.item.parts.SiteLine;
      }

      if (!this.spt) {
        this.spt = new SVGSprite(viewObj);
      }
      this.spt.x = this.itemInfo.x;
      this.spt.y = this.itemInfo.y;
      this.spt.update();

      // 中央原点になるよに、ドット変換
      this.convertDotsToCenter();
      this.inputMode = SITE_INPUT_MODE.SITE_SIMPLE_INPUT_MODE;
      if (marietta.webcad.WebCADGlobal.webcad2Dmanager.currentSiteInputMode === SITE_INPUT_MODE.SITE_DETAILED_INPUT_MODE) {
        this.inputMode = SITE_INPUT_MODE.SITE_DETAILED_INPUT_MODE;
        let baseSide;
        if (this.itemInfo.baseNo) {
          for (let i = 0; i < this.lines.length; i += 1) {
            if (this.lines[i].index === this.itemInfo.baseNo) {
              baseSide = this.lines[i];
              break;
            }
          }
        } else {
          baseSide = this.getLongestSide();
        }
        this.showAltitude(baseSide);
      }
    }

    /**
     * 中央原点になるように
     */
    convertDotsToCenter() {
      // 全てのドットを見て中心に合わせる
      let i: number;
      let minX: number = this.itemInfo.dotList[0].x;
      let minY: number = this.itemInfo.dotList[0].y;
      let maxX: number = this.itemInfo.dotList[0].x;
      let maxY: number = this.itemInfo.dotList[0].y;

      for (i = 0; i < this.itemInfo.dotList.length; i += 1) {
        if (this.itemInfo.dotList[i].x < minX) { minX = this.itemInfo.dotList[i].x; }
        if (this.itemInfo.dotList[i].y < minY) { minY = this.itemInfo.dotList[i].y; }
        if (this.itemInfo.dotList[i].x > maxX) { maxX = this.itemInfo.dotList[i].x; }
        if (this.itemInfo.dotList[i].y > maxY) { maxY = this.itemInfo.dotList[i].y; }
      }

      const centerX: number = minX + (maxX - minX) / 2;
      const centerY: number = minY + (maxY - minY) / 2;

      // 各頂点を変更
      for (i = 0; i < this.itemInfo.dotList.length; i += 1) {
        this.itemInfo.dotList[i].x -= centerX;
        this.itemInfo.dotList[i].y -= centerY;
      }
      this.nuriView.setAttribute('d', marietta.webcad.util.SVGUtil.getPathString(this.itemInfo.dotList));

      // 移動
      this.move(this.itemInfo.x + centerX, this.itemInfo.y + centerY);

      // テキストの移動
      let text: marietta.webcad.item.parts.SiteText;
      let line: marietta.webcad.item.parts.SiteLine;
      let road: marietta.webcad.item.parts.SiteRoad;
      for (i = 0; i < this.stretchLineTexts.length; i += 1) {
        road = this.roads[i];
        road.firstDot = this.itemInfo.dotList[i].point;
        text = this.stretchLineTexts[i];
        text.firstDot = this.itemInfo.dotList[i].point;
        line = this.stretchLines[i];
        line.firstDot = this.itemInfo.dotList[i].point;
        if (i === this.stretchLineTexts.length - 1) {
          road.secondDot = this.itemInfo.dotList[0].point;
          text.secondDot = this.itemInfo.dotList[0].point;
          line.secondDot = this.itemInfo.dotList[0].point;
        } else {
          road.secondDot = this.itemInfo.dotList[i + 1].point;
          text.secondDot = this.itemInfo.dotList[i + 1].point;
          line.secondDot = this.itemInfo.dotList[i + 1].point;
        }
        road.updateTransforms();
      }
    }

    /**
     * 現行のTransform
     */
    getCurrentTransform() {
      let retTransform = '';
      retTransform += `translate( ${this.itemInfo.x}, ${this.itemInfo.y} ) `;
      retTransform += `rotate( ${this.itemInfo.rotation} ) `;
      return retTransform;
    }

    /**
     * 延床面積の計算
     */
    getArea(): number {
      return marietta.webcad.util.WebCADUtil.calculateArea(this.itemInfo.dotList);
    }

    /**
     * 頂点情報の取得
     */
    private getPointInfo(): marietta.webcad.collection.PointCollection[] {
      const dotList: marietta.webcad.collection.PointCollection[] = [];
      let point: any;
      let pointCollection: marietta.webcad.collection.PointCollection;
      for (let i = 0, len = this.itemInfo.dotList.length; i < len; i += 1) {
        point = new marietta.core.Point(this.itemInfo.dotList[i].x, this.itemInfo.dotList[i].y);
        point = this.spt.localToGlobal(point);
        point.x /= marietta.webcad.WebCADGlobal.scaleSize;
        point.y /= marietta.webcad.WebCADGlobal.scaleSize;

        pointCollection = new marietta.webcad.collection.PointCollection(point.x, point.y);
        pointCollection.road_w = this.itemInfo.dotList[i].road_w;
        pointCollection.road_lr = this.itemInfo.dotList[i].road_lr;

        dotList.push(pointCollection);
      }
      return dotList;
    }

    /**
     * 保存用データ（ドットXML)
     */
    getPointXML(): Element[] {
      const pointNodeList = [];
      let pointNode;
      const dotList: marietta.webcad.collection.PointCollection[] = this.getPointInfo();

      for (let i = 0, len = dotList.length; i < len; i += 1) {
        pointNode = document.createElementNS(null, 'point');
        pointNode.setAttribute('index', String(i + 1));

        pointNode.setAttribute('x', String(dotList[i].x));
        pointNode.setAttribute('y', String(-(dotList[i].y - marietta.webcad.WebCADGlobal.LAYER_SIZE_H)));
        pointNode.setAttribute('road_w', String(dotList[i].road_w));
        pointNode.setAttribute('road_lr', String(Number(dotList[i].road_lr)));
        pointNodeList.push(pointNode);
      }
      return pointNodeList;
    }

    getLongestSide(): marietta.webcad.item.parts.SiteLine {
      let maxDistance: number = 0;
      let length: number = 0;
      let base: marietta.webcad.item.parts.SiteLine = null;
      for (let i: number = 0; i < this.lines.length; i += 1) {
        length = marietta.core.Point.distance(this.lines[i].firstDot, this.lines[i].secondDot);
        if (maxDistance < length) {
          maxDistance = length;
          base = this.lines[i];
        }
      }
      return base;
    }

    /**
     * 高度線
     * @param baseline
     */
    showAltitude(baseline: marietta.webcad.item.parts.SiteLine): void {
      this.baseSideLine = baseline;
      this.itemInfo.baseNo = this.baseSideLine.index;

      if (document.getElementById(`altitude_line_${this.itemInfo.guid}`)) {
        const altLine: SVGSprite = new SVGSprite(document.getElementById(`altitude_line_${this.itemInfo.guid}`));
        altLine.remove();
      }
      if (document.getElementById(`altitude_line_text_${this.itemInfo.guid}`)) {
        const altLineText: SVGSprite = new SVGSprite(document.getElementById(`altitude_line_text_${this.itemInfo.guid}`));
        altLineText.remove();
      }

      const altitudeLine: marietta.webcad.item.parts.SiteAltitudeLine = new marietta.webcad.item.parts.SiteAltitudeLine(this.altitudeView, this.itemInfo.guid);
      this.altitudeInfo = this.getAltitudeFromBase(this.baseSideLine);
      altitudeLine.firstDot = this.altitudeInfo.topDot;
      altitudeLine.secondDot = new marietta.core.Point(this.altitudeInfo.pX, this.altitudeInfo.pY);
      altitudeLine.updateTransforms();

      const altitudeLineText: marietta.webcad.item.parts.SiteAltitudeLineText = new marietta.webcad.item.parts.SiteAltitudeLineText(this.altitudeView, this.itemInfo.guid);
      altitudeLineText.centerPoint = marietta.core.Point.interpolate(altitudeLine.firstDot, altitudeLine.secondDot, 0.5);
      altitudeLineText.rotation = Math.round((this.altitudeInfo.angle + 90) + 180 * Number(Boolean(this.altitudeInfo.angle + 90 > 90 || this.altitudeInfo.angle + 90 < -90)));
      altitudeLineText.distance = this.altitudeInfo.length;
      altitudeLineText.updateTransforms();
      this.altitudelineText = altitudeLineText;
    }

    /**
     * 三斜入力：高度
     * @param base
     * @returns
     */
    getAltitudeFromBase(base: marietta.webcad.item.parts.SiteLine): marietta.webcad.collection.AltitudeLineInfoCollection {
      const altInfo: marietta.webcad.collection.AltitudeLineInfoCollection = new marietta.webcad.collection.AltitudeLineInfoCollection();
      let snapUnit = marietta.webcad.WebCADGlobal.webcad2Dmanager.snapUnitPix;
      let index = base.index - 2;
      if (index < 0) index = 2;
      const topPoint: marietta.core.Point = this.lines[index].firstDot;
      const angle: number = Math.atan2(base.secondDot.x - base.firstDot.x, -(base.secondDot.y - base.firstDot.y)) * (180 / Math.PI) - 90;
      const m1: number = Math.tan((angle * Math.PI) / 180);
      const m2: number = Math.tan(((angle + 90) * Math.PI) / 180);

      const Px: number = (m2 * topPoint.x - m1 * base.firstDot.x + base.firstDot.y - topPoint.y) / (m2 - m1);
      const Py: number = m1 * (Px - base.firstDot.x) + base.firstDot.y;
      const Lc: number = Math.sqrt(((topPoint.x - Px) ** 2) + ((topPoint.y - Py) ** 2));
      altInfo.length = Math.round(marietta.webcad.util.WebCADUtil.convertPixToMM(Lc));
      snapUnit = 1;
      altInfo.pX = Math.round(Px / snapUnit) * snapUnit;
      altInfo.pY = Math.round(Py / snapUnit) * snapUnit;
      altInfo.LC = Lc;
      altInfo.angle = angle;
      altInfo.topDot = topPoint;
      return altInfo;
    }

    /**
     * 入力データに基づいて敷地の形状を変更
     * @param A
     * @param B
     * @param C
     */
    chageSiteShape(A: number, B: number, C: number) {
      const motoPlace: marietta.core.Point = new marietta.core.Point(0, 0);
      const newDotPlus: marietta.core.Point = new marietta.core.Point(0, 0);
      const nnewDotMinus: marietta.core.Point = new marietta.core.Point(0, 0);
      // const baseLine: marietta.webcad.item.parts.SiteLine = this.baseSideLine;

      const leftSide: number = marietta.webcad.util.WebCADUtil.convertMMToPix(C);
      const rightSide: number = marietta.webcad.util.WebCADUtil.convertMMToPix(B);
      const baseLength: number = marietta.webcad.util.WebCADUtil.convertMMToPix(A);

      const baseAngle: number = Math.atan2(this.itemInfo.dotList[1].x - this.itemInfo.dotList[0].x, this.itemInfo.dotList[1].y - this.itemInfo.dotList[0].y);
      // 作成済みの uuid を保持
      let uuid = this.itemInfo.dotList[1].guid;
      this.itemInfo.dotList[1] = new marietta.webcad.collection.PointCollection(this.itemInfo.dotList[0].x + Math.sin(baseAngle) * baseLength, this.itemInfo.dotList[0].y + Math.cos(baseAngle) * baseLength);
      this.itemInfo.dotList[1].guid = uuid;
      const newAngle: number = Math.acos(((baseLength ** 2) + (leftSide ** 2) - (rightSide ** 2)) / (2 * baseLength * leftSide));
      newDotPlus.x = this.itemInfo.dotList[0].x + leftSide * Math.sin(baseAngle + newAngle);
      newDotPlus.y = this.itemInfo.dotList[0].y + leftSide * Math.cos(baseAngle + newAngle);
      nnewDotMinus.x = this.itemInfo.dotList[0].x + leftSide * Math.sin(baseAngle - newAngle);
      nnewDotMinus.y = this.itemInfo.dotList[0].y + leftSide * Math.cos(baseAngle - newAngle);

      motoPlace.x = this.itemInfo.dotList[2].x;
      motoPlace.y = this.itemInfo.dotList[2].y;
      uuid = this.itemInfo.dotList[2].guid;
      if (marietta.core.Point.distance(motoPlace, newDotPlus) < marietta.core.Point.distance(motoPlace, nnewDotMinus)) {
        this.itemInfo.dotList[2] = new marietta.webcad.collection.PointCollection(newDotPlus.x, newDotPlus.y);
      } else {
        this.itemInfo.dotList[2] = new marietta.webcad.collection.PointCollection(nnewDotMinus.x, nnewDotMinus.y);
      }
      this.itemInfo.dotList[2].guid = uuid;
      this.reCreateImage();
    }

    /**
     * 子供を表示
     */
    showChildren=(): void => {
      for (let i: number = 0; i < this.stretchLineTexts.length; i += 1) {
        this.roads[i].show();
        this.stretchLines[i].show();
        this.stretchLineTexts[i].show();
      }
    }

    /**
    * 子供を隠す
    */
    hideChildren=(): void => {
      for (let i: number = 0; i < this.stretchLineTexts.length; i += 1) {
        this.roads[i].hide();
        this.stretchLines[i].hide();
        this.stretchLineTexts[i].hide();
      }
    }
}
